import { Component } from 'react';
import { connect } from 'react-redux';

import { RootState, ToolTipType } from 'types';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { checkDifferent, clone } from 'utils/formHandlers';

import EnviromentalToolTipStatic from './toolTips/EnviromentalToolTipStatic';
import VesselToolTipStatic from './toolTips/VesselToolTipStatic';

interface StaticToolTipProps {
    tooltips: ToolTipType[];
    currentTime?: DateTimeFormat;
    manoeuvre?: boolean;
    mode: string;
    enviromental?: boolean;
    updateTooltips: (x: number, y: number, uuid: string | null) => void;
}

interface StaticToolTipState {
    tooltips: ToolTipType[];
    currentTime: DateTimeFormat | null;
}

class StaticToolTip extends Component<StaticToolTipProps, StaticToolTipState> {
    constructor(props: StaticToolTipProps) {
        super(props);
        this.state = {
            tooltips: clone(props.tooltips),
            currentTime: null,
        };
    }

    static getDerivedStateFromProps(props: StaticToolTipProps, state: StaticToolTipState) {
        if (props.currentTime?.toTimestamp() != state.currentTime?.toTimestamp()) {
            console.log('time update');
            return { currentTime: clone(props.currentTime) };
        }

        if (checkDifferent(props.tooltips, state.tooltips)) {
            return { tooltips: clone(props.tooltips) };
        }

        return null;
    }

    render() {
        return (
            <>
                {this.props.mode === 'playback' && (
                    <div className="z-20 gap-2 flex absolute  right-2 top-4 flex-col">
                        <VesselToolTipStatic mode="playback" currentTime={this.state.currentTime} />
                        <EnviromentalToolTipStatic currentTime={this.state.currentTime} />
                    </div>
                )}
            </>
        );
    }
}

const toolTipStateToProps = (state: RootState) => ({
    map: state.map.map,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const toolTipDispatchToProps = () => ({});

export default connect(toolTipStateToProps, toolTipDispatchToProps)(StaticToolTip);
